import { createRoot } from 'react-dom/client';
import { RootProviders } from './root-providers';
import { render as wrappedRenderV1 } from './wrapped-render';
import { isEnabled } from '@bamboohr/utils/lib/feature';

/**
 * create root and render (react18 way of rendering)
 * @param {{
 *   attachedElement?: Element | DocumentFragment | null;
 *   callback?: (root: import('react-dom/client').Root) => void;
 *   children: React.ReactNode;
 *   root?: import('react-dom/client').Root;
 *   safe?: boolean;
 *   themeProps?: import("@bamboohr/fabric/dist/styles/types").ThemeProviderProps;
 * }} opts
 * @returns {import('react-dom/client').Root | undefined} The root instance
 */
export function render({
	root,
	children,
	attachedElement,
	callback,
	themeProps,
	safe = false
}) {
	if (safe && !attachedElement) {
		console.error(
			"'attachedElement' provided to 'renderV2' was 'null' or 'undefined'",
		);
		return;
	}

	if (!root) {
		root = createRoot(attachedElement);
	}

	root.render(
		<RootProviders themeProps={themeProps}>
			{children}
		</RootProviders>
	);
	if (callback) {
		requestIdleCallback(() => callback(root));
	}
	return root;
}

/**
 * use old or new wrapped render based on release toggle
 * @param {{ root?: import('react-dom/client').Root; children: React.ReactNode; attachedElement: Element | DocumentFragment | null; callback?: (root: ReactDOM.Renderer) => void; themeProps?: import("@bamboohr/fabric/dist/styles/types").ThemeProviderProps; safe?: boolean; }} opts
 * @returns {import('react-dom/client').Root | undefined} The root instance
 */
export function renderV2(opts) {
	return isEnabled('REACT_18_RENDER_PO')
		? render(opts)
		: wrappedRenderV1(opts.children, opts.attachedElement, opts.callback, opts.themeProps, opts.safe);
}

export default { renderV2 };
